export default {
  Toolbar: {
    Title: {
      Phone: 'Κωδικός Επαλήθευσης Κινητού',
      Email: 'Κωδικός Επαλήθευσης Email'
    }
  },

  Title: {
    Phone: 'Εισάγετε τον κωδικό επαλήθευσης που λάβατε στο κινητό σας',
    Email: 'Εισάγετε τον κωδικό επαλήθευσης που λάβατε στο email σας'
  },

  ExpiresIn: 'Λήγει σε'
}
